<template>
  <div class="modal custom-modal fade request-modal" id="profile-coach" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">Coach Profile</h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Court Request -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card dashboard-card court-information">
                <div class="profile-set">
                  <div class="profile-set-image">
                    <img src="@/assets/img/featured/featured-05.jpg" alt="Venue" />
                  </div>
                  <div class="profile-set-content">
                    <h3>Kevin Anderson</h3>
                    <div class="rating-city">
                      <div class="profile-set-rating">
                        <span>4.5</span>
                        <h6>300 Reviews</h6>
                      </div>
                      <div class="profile-set-img">
                        <img src="@/assets/img/flag/usa.png" alt="User" />
                        <h6>Santamanica, United states</h6>
                      </div>
                    </div>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting
                      industry.industry's
                    </p>
                    <ul>
                      <li>
                        <img src="@/assets/img/icons/rank.svg" alt="Icon" />
                        <h6>Rank : Expert</h6>
                      </li>
                      <li>
                        <img src="@/assets/img/icons/process.svg" alt="Icon" />
                        <h6>Sessions Completed : 25</h6>
                      </li>
                      <li>
                        <img src="@/assets/img/icons/calendar-alt.svg" alt="Icon" />
                        <h6>With Dreamsport since<span> Apr 5, 2023</span></h6>
                      </li>
                    </ul>
                  </div>
                  <div class="price-set-price">
                    <h6>Start’s From</h6>
                    <h5>$250<span>/hr</span></h5>
                  </div>
                </div>
              </div>
              <div class="profile-tab">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Profile Info
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="appointment-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#appointment"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Appointment Details
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="reviews-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#reviews"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Reviews
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="previous-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#previous"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Previous Booking
                    </button>
                  </li>
                </ul>
                <div class="tab-content">
                  <div
                    class="tab-pane fade show active"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div class="profile-card mb-0">
                      <div class="profile-card-title">
                        <h4>Contact Information</h4>
                      </div>
                      <div class="profile-contact-details">
                        <ul>
                          <li>
                            <span>Email Address</span>
                            <h6>contact@example.com</h6>
                          </li>
                          <li>
                            <span>Phone Number</span>
                            <h6>+1 56565 556558</h6>
                          </li>
                          <li>
                            <span> Address</span>
                            <h6>1653 Davisson Street,Indianapolis, IN 46225</h6>
                          </li>
                        </ul>
                      </div>
                      <div class="profile-card-title">
                        <h4>Short Bio</h4>
                      </div>
                      <div class="profile-card-content">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius
                          consectetur a at est diam ultricies. Egestas eros leo dapibus
                          tellus neque turpis. Nec in morbi adipiscing pretium accumsan
                          urna ac,Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                          Varius consectetur a at est diam ultricies. Egestas eros leo
                          dapibus tellus neque turpis. Nec in morbi adipiscing pretium
                          accumsan urna ac,Lorem ipsum dolor sit amet, consectetur
                          adipiscing elit. Varius consectetur a at est diam ultricies.
                          Egestas eros leo dapibus tellus neque turpis. Nec in morbi
                          adipiscing pretium accumsan urna ac,
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="appointment"
                    role="tabpanel"
                    aria-labelledby="appointment-tab"
                  >
                    <!-- Accordian Contents -->
                    <div class="accordion">
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/short-bio.svg" alt="Icon"
                            /></span>
                            Short Bio
                          </button>
                        </h4>
                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="text show-more-height">
                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the
                                1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker including versions of Lorem
                                Ipsum
                              </p>

                              <ul>
                                <li>4 years of high school (3 years varsity)</li>
                                <li>
                                  3 years of college club badminton at Loyola Marymount
                                </li>
                                <li>
                                  I grew up at North Venice Little League and represented
                                </li>
                                <li>
                                  Southern California in 2017 for Senior State Champs.
                                </li>
                                <li>
                                  3 years on Varsity at Venice High School. Venice Varsity
                                </li>
                                <li>badminton Western League Champs 2017.</li>
                                <li>
                                  2 years of Loyola Marymount University Club badminton.
                                </li>
                              </ul>

                              <p>
                                It was popularised in the 1960s with the release of
                                Letraset sheets containing Lorem Ipsum passages, and more
                                recently with desktop publishing software like Aldus
                                PageMaker including versions of Lorem Ipsum
                              </p>

                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the
                                1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker including versions of Lorem
                                Ipsum
                              </p>

                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged.
                              </p>

                              <p>
                                It was popularised in the 1960s with the release of
                                Letraset sheets containing Lorem Ipsum passages, and more
                                recently with desktop publishing software like Aldus
                                PageMaker including versions of Lorem Ipsum
                              </p>
                            </div>
                            <div class="show-more d align-items-center primary-text">
                              <i class="feather-plus-circle"></i>Show More
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img
                                src="@/assets/img/icons/lesson-with-me.svg"
                                alt="Icon"
                            /></span>
                            Lesson With me
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <p>
                              Lorem Ipsum is simply dummy text of the printing and
                              typesetting industry. Lorem Ipsum has been the industry's
                              standard dummy text ever since the 1500s, when an unknown
                              printer took a galley of type and scrambled it to make a
                              type specimen book. It has survived not only five centuries,
                              but also the leap into electronic typesetting, remaining
                              essentially unchanged. It was popularised in the 1960s with
                              the release of Letraset sheets containing Lorem Ipsum
                              passages, and more recently with desktop publishing software
                              like Aldus PageMaker including versions of Lorem Ipsum
                            </p>
                            <ul>
                              <li><i class="feather-check-square"></i>Single Lesson</li>
                              <li><i class="feather-check-square"></i>2 Player Lesson</li>
                              <li>
                                <i class="feather-check-square"></i>Small group Lesson
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/coaching.svg" alt="Icon"
                            /></span>
                            Coaching
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <p>
                              Lorem Ipsum is simply dummy text of the printing and
                              typesetting industry. Lorem Ipsum has been the industry's
                              standard dummy text ever since the 1500s, when an unknown
                              printer took a galley of type and scrambled it to make a
                              type specimen book. It has survived not only five centuries,
                              but also the leap into electronic typesetting, remaining
                              essentially unchanged. It was popularised in the 1960s with
                              the release of Letraset sheets containing Lorem Ipsum
                              passages, and more recently with desktop publishing software
                              like Aldus PageMaker including versions of Lorem Ipsum
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/gallery.svg" alt="Icon"
                            /></span>
                            Gallery
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="owl-carousel gallery-slider owl-theme">
                              <div>
                                <img
                                  class="img-fluid"
                                  alt="Image"
                                  src="@/assets/img/gallery/gallery4/gallery-15.jpg"
                                />
                              </div>
                              <div>
                                <img
                                  class="img-fluid"
                                  alt="Image"
                                  src="@/assets/img/gallery/gallery4/gallery-16.jpg"
                                />
                              </div>
                              <div>
                                <img
                                  class="img-fluid"
                                  alt="Image"
                                  src="@/assets/img/gallery/gallery4/gallery-17.jpg"
                                />
                              </div>
                              <div>
                                <img
                                  class="img-fluid"
                                  alt="Image"
                                  src="@/assets/img/gallery/gallery4/gallery-16.jpg"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/location.svg" alt="Icon"
                            /></span>
                            Location
                          </button>
                        </h4>
                        <div id="panelsStayOpen-collapseSeven" class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="google-maps">
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.8862835683544!2d-73.98256668525309!3d41.93829486962529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89dd0ee3286615b7%3A0x42bfa96cc2ce4381!2s132%20Kingston%20St%2C%20Kingston%2C%20NY%2012401%2C%20USA!5e0!3m2!1sen!2sin!4v1670922579281!5m2!1sen!2sin"
                                height="170"
                                style="border: 0"
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                              ></iframe>
                            </div>
                            <div
                              class="dull-bg d-flex justify-content-start align-items-center mb-3"
                            >
                              <div class="white-bg me-2">
                                <i class="fas fa-location-arrow"></i>
                              </div>
                              <div class="">
                                <h6>Our Venue Location</h6>
                                <p>70 Bright St New York, USA</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Accordian Contents -->
                  </div>
                  <div
                    class="tab-pane fade"
                    id="reviews"
                    role="tabpanel"
                    aria-labelledby="reviews-tab"
                  >
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <span class="">5.0</span>
                        </div>
                        <span class="success-text"
                          ><i class="feather-check"></i>Yes, I would book again.</span
                        >
                        <h6>Absolutely perfect</h6>
                        <p>
                          If you are looking for a perfect place for friendly matches with
                          your friends or a competitive match, It is the best place.
                        </p>
                        <ul class="review-gallery">
                          <li
                            v-for="(image, index) in galleryImages"
                            :key="index"
                            @click="() => show(index)"
                            data-aos="fade-down"
                          >
                            <a href="javascript:;" data-fancybox="gallery">
                              <img
                                :src="require(`@/assets/img/gallery/${image.src}`)"
                                class="img-fluid"
                                alt="Image"
                              />
                            </a>
                          </li>
                        </ul>
                        <span class="post-date">Sent on 11/03/2023</span>
                      </div>
                    </div>
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <span class="">5.0</span>
                        </div>
                        <h6>Awesome. Its very convenient to play.</h6>
                        <p>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy
                          text ever since the 1500s, when an unknown printer took a galley
                          of type and scrambled it to make a type specimen book. It has
                          survived not only five centuries, but also the leap into
                          electronic!!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="previous"
                    role="tabpanel"
                    aria-labelledby="previous-tab"
                  >
                    <div class="preview-tab">
                      <ul>
                        <li>
                          <div class="preview-tabcontent">
                            <div class="preview-tabimg">
                              <img
                                src="@/assets/img/services/service-01.jpg"
                                alt="Service"
                              />
                            </div>
                            <div class="preview-tabname">
                              <h4>Leap Sports Academy</h4>
                              <h5>Court 1</h5>
                              <ul>
                                <li><span>Guests : 4</span></li>
                                <li><span>2 Hrs</span></li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li>
                          <h6>Date & Time</h6>
                          <span class="d-block">Mon, Jul 11</span>
                          <span>06:00 PM - 08:00 PM</span>
                        </li>
                        <li>
                          <h6>$400</h6>
                        </li>
                      </ul>
                    </div>
                    <div class="preview-tab">
                      <ul>
                        <li>
                          <div class="preview-tabcontent">
                            <div class="preview-tabimg">
                              <img
                                src="@/assets/img/services/service-02.jpg"
                                alt="Service"
                              />
                            </div>
                            <div class="preview-tabname">
                              <h4>Marsh Academy</h4>
                              <h5>Court 1</h5>
                              <ul>
                                <li><span>Guests : 4</span></li>
                                <li><span>2 Hrs</span></li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li>
                          <h6>Date & Time</h6>
                          <span class="d-block">Mon, Jul 11</span>
                          <span>06:00 PM - 08:00 PM</span>
                        </li>
                        <li>
                          <h6>$300</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Court Request -->
        </div>
      </div>
    </div>
  </div>
  <vue-easy-lightbox
    :visible="visible"
    :index="index"
    :imgs="
      galleryImages.map((image) => ({
        src: require(`@/assets/img/gallery/${image.src}`),
      }))
    "
    @hide="visible = false"
    @on-prev="handlePrev"
    @on-next="handleNext"
  >
  </vue-easy-lightbox>
</template>
<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  data() {
    return {
      visible: false,
      index: 0,
      galleryImages: [
        {
          src: "gallery-01.jpg",
        },
        {
          src: "gallery-02.jpg",
        },
        {
          src: "gallery-03.jpg",
        },
        {
          src: "gallery-04.jpg",
        },
        {
          src: "gallery-05.jpg",
        },
      ],
    };
  },
  components: {
    VueEasyLightbox,
  },
  methods: {
    show(index) {
      this.index = index;
      this.visible = true;
    },
    handlePrev(oldIndex, newIndex) {},
    handleNext(oldIndex, newIndex) {},
  },
};
</script>
